var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrivateProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_private_profile_svg__clip0_11470_377332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#EBF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.4c3.603 0 5.404 2.7 5.404 5.4 0 3-.625 4.124-1.876 5.458a.89.89 0 00.206 1.392c1.204.67 3.181 1.86 4.372 3.05 1.508 1.507 1.753 4.911 1.794 8.092a1.789 1.789 0 01-1.792 1.808H7.89A1.789 1.789 0 016.1 30.792c.04-3.18.284-6.584 1.794-8.093 1.19-1.19 3.168-2.378 4.372-3.049a.89.89 0 00.206-1.392c-1.25-1.334-1.876-2.459-1.876-5.458 0-2.7 1.802-5.4 5.403-5.4zm-3.312 20.044l2.954 2.239 2.87-2.233-1.862-7.447c-.709.06-1.428.06-2.137-.003l-1.825 7.444z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_private_profile_svg__clip0_11470_377332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#fff"
  })))));
}

export default SvgIconPrivateProfile;